import {AxiosResponse} from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";
export async function checkRedemptionPath(fundCode: Number) {
    try { 
        const path = environment.BASE_URL + "MemberDetails/CheckRedemptionPath";
        const res: AxiosResponse<any> = await dal.post(path, {fundCode: Number(fundCode)})
        if (axiosUtil.isSuccess(res) && res?.data.errorCode === 0) {
            return res.data;
        }
        else{
            return res.data
        }
    } catch (err) {
        console.log(err); 
    }
}